<template>
    <div class="stepper" 
             :class="{'stepper--on-step-zero': isStep('zero'),'stepper--on-step-one': isStep('one'),'stepper--on-step-two': isStep('two'),'stepper--on-step-three': isStep('three'),}"
    >
        <div class="stepper__step stepper__step--first">
            <div class="stepper__num ">1</div>
            <div class="stepper__title">Расчет</div>
        </div>

        <div class="stepper__step stepper__step--sec">
            <div class="stepper__num">2</div>
            <div class="stepper__title">Оформление</div>
        </div>

        <div class="stepper__step stepper__step--third">
            <div class="stepper__num">3</div>
            <div class="stepper__title">Оплата</div>
        </div>
    </div>
</template>

<script>
import { useContractsStore } from '@/create/store/contracts';

    export default {
        data() {
            return {
                contractStore: useContractsStore(),
               
            }
        },
        methods: {
            isStep(item) {
                return this.contractStore.contractStep === item
            },
        },
    }
</script>

<style lang="scss" scoped>
@media (max-width: 480px) {
    .stepper {
        margin: 30px 10px;
    }
}
</style>